const key = value => typeof value === 'string' && /^[A-Za-z0-9_.:-]{1,120}$/.test(value);
const recordId = value => typeof value === 'string' && /^[A-Za-z0-9]{15}(?:[A-Za-z0-9]{3})?$/.test(value);

export function workspaceLink(kind, id, slug = 'riomax', origin = window.location.origin) {
  if (!/^[a-z0-9-]+$/.test(slug) || !key(id) || !['project', 'idea', 'case'].includes(kind)
    || (kind !== 'idea' && !recordId(id))) throw new Error('This record does not have a shareable link.');
  const url = new URL(`/e/${slug}`, origin);
  url.searchParams.set('app', kind === 'project' ? 'projects' : 'ideas');
  url.searchParams.set(kind === 'project' ? 'ticket' : kind, id);
  return url.href;
}

export function workspaceTargetFromUrl(href = window.location.href) {
  const url = new URL(href);
  for (const [param, kind, app] of [['ticket', 'project', 'projects'], ['idea', 'idea', 'ideas'], ['case', 'case', 'ideas']]) {
    const id = url.searchParams.get(param);
    if (url.searchParams.getAll(param).length !== 1 || !key(id) || (kind !== 'idea' && !recordId(id)) || url.searchParams.get('app') !== app) continue;
    return { kind, app, recordId: id, requestId: `link:${kind}:${id}` };
  }
  return null;
}
